const key = 'qk_newsletter';
let lastAttribute = null;
let timer;
function consentAllowed() {
  const privacy = window.Shopify?.customerPrivacy;
  return Boolean(privacy?.analyticsProcessingAllowed() && privacy?.marketingAllowed());
}
async function capture() {
  const rawCookie = document.cookie.split('; ').find(c => c.startsWith(`${key}=`))?.slice(key.length + 1);
  if (!consentAllowed()) {
    document.cookie = `${key}=; Max-Age=0; Path=/; Secure; SameSite=Lax`;
    if (rawCookie || lastAttribute) await writeAttribute('');
    return;
  }
  const url = new URL(location.href), incoming = url.searchParams.get('qk_nl');
  if (incoming && /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(incoming) && incoming.length < 500) {
    document.cookie = `${key}=${encodeURIComponent(incoming)}; Max-Age=604800; Path=/; Secure; SameSite=Lax`;
    url.searchParams.delete('qk_nl'); history.replaceState(history.state, '', url.href);
  }
  const stored = document.cookie.split('; ').find(c => c.startsWith(`${key}=`))?.slice(key.length + 1);
  if (!stored) return;
  const token = decodeURIComponent(stored);
  if (/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(token) && token.length < 500) await writeAttribute(token);
}
async function writeAttribute(value) {
  if (lastAttribute === value) return;
  const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { [key]: value } }) });
  if (response.ok) lastAttribute = value;
}
function scheduleRecovery(cart) {
  clearTimeout(timer);
  // Only the Shopify app proxy can establish the logged-in customer. No browser email is sent.
  if (!consentAllowed() || !window.qkNewsletterCartRecovery || !cart?.items?.length) return;
  timer = setTimeout(() => {
    void fetch('/apps/qk-newsletter/cart', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ cartToken: cart.token, lines: cart.items.slice(0, 100).map(item => ({ variantId: String(item.variant_id), quantity: item.quantity })) }) }).catch(() => {});
  }, 1000);
}
function safeCapture() { void capture().catch(() => {}); }
document.addEventListener('visitorConsentCollected', safeCapture);
document.addEventListener('cart:change', event => { safeCapture(); scheduleRecovery(event.detail?.cart); });
if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) safeCapture(); });
